export default "__VITE_ASSET__dff87a27__"